import React, { FC, FormHTMLAttributes, ReactNode } from 'react';
import {
  FieldValues,
  useForm,
  UseFormHandleSubmit,
  UseFormRegister,
} from 'react-hook-form';

export interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  children: (data: any) => ReactNode;
  handleOnSubmit: (data: any) => void;
}

export const Form: FC<FormProps> = ({
  children,
  handleOnSubmit,
  ...rest
}: FormProps) => {
  /* Checking for missing required props */
  // if (!handleOnSubmit)
  //   throw new Error(
  //     `You need to pass a prop called "handleOnSubmit" of type void to the Form component. To learn more about the list of required props for the
  //     Form component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-form--form`
  //   );
  // if (!children)
  //   throw new Error(
  //     `You need to pass a prop called "children" of type ReactNode to the Form component. To learn more about the list of required props for the
  //     Form component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/form-form--form`
  //   );
  /* Checking for missing required props */
  const { register, handleSubmit } = useForm<
    UseFormRegister<FieldValues>,
    UseFormHandleSubmit<FieldValues>
  >({
    shouldUseNativeValidation: true,
  });
  return (
    <form onSubmit={handleSubmit(handleOnSubmit)} {...rest}>
      {children && children({ register })}
    </form>
  );
};
